/**
 * The drone-aura rings the board draws (`ll1-drones` 9.1): one Burst per placed, not Destroyed drone
 * carrying an `auraProfile` (`decisions/0201` D2), as the cells `squareSpace.disk` gives for its
 * space and radius, the same disk the engine's `aura.ts` tests membership against. Square grid only,
 * like the area-effect clouds.
 */
import { hasStatus, type Combatant } from "@lancer-vtt/domain";
import { squareSpace } from "@lancer-vtt/space";

/** One drone's field: its id and the cells inside it. */
export type DroneAuraRing = { droneId: string; cells: { x: number; y: number }[] };

/** The rings for every live aura drone in `combatants`, in id order. */
export function droneAuraRings(combatants: readonly Combatant[]): DroneAuraRing[] {
  return [...combatants]
    .sort((a, b) => a.id.localeCompare(b.id))
    .flatMap((c) => {
      const pos = c.pos;
      if (c.auraProfile === undefined || pos?.grid !== "square" || hasStatus(c.statuses, "Destroyed")) return [];
      return [{ droneId: c.id, cells: [...squareSpace.disk({ x: pos.x, y: pos.y }, c.auraProfile.radius).cells()] }];
    });
}
